import { motion } from "framer-motion"
import styled from "styled-components"

const lineAnimations = {
  variants: {
    hidden: {
      scaleY: [1, 0.8, 0.8, 0],
      originY: "100%",
      transition: {
        times: [0, 0.1, 0.8, 1],
        duration: 0.8,
        ease: "easeIn",
      },
    },
    visible: {
      scaleY: [0, 0.8, 1],
      transition: {
        times: [0, 0.2, 1],
        duration: 0.8,
        ease: "easeOut",
      },
    },
  },
  initial: "hidden",
  animate: "visible",
  exit: "hidden",
}

const Container = styled(motion.div)`
  position: absolute;
  width: 1px;
  top: 16vh;
  height: calc(42vh - 16vh + 30px);
  background: rgb(128, 128, 128);
`

const Line = () => <Container {...lineAnimations} />

export default Line
